/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DismissSkillSuggestionRequestBody,
  DismissSkillSuggestionRequestBody$Outbound,
  DismissSkillSuggestionRequestBody$outboundSchema,
} from "../components/dismissskillsuggestionrequestbody.js";

export type DismissSkillSuggestionSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DismissSkillSuggestionSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DismissSkillSuggestionSecurity = {
  option1?: DismissSkillSuggestionSecurityOption1 | undefined;
  option2?: DismissSkillSuggestionSecurityOption2 | undefined;
};

export type DismissSkillSuggestionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  dismissSkillSuggestionRequestBody: DismissSkillSuggestionRequestBody;
};

/** @internal */
export type DismissSkillSuggestionSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DismissSkillSuggestionSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DismissSkillSuggestionSecurityOption1$Outbound,
    DismissSkillSuggestionSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function dismissSkillSuggestionSecurityOption1ToJSON(
  dismissSkillSuggestionSecurityOption1: DismissSkillSuggestionSecurityOption1,
): string {
  return JSON.stringify(
    DismissSkillSuggestionSecurityOption1$outboundSchema.parse(
      dismissSkillSuggestionSecurityOption1,
    ),
  );
}

/** @internal */
export type DismissSkillSuggestionSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DismissSkillSuggestionSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DismissSkillSuggestionSecurityOption2$Outbound,
    DismissSkillSuggestionSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function dismissSkillSuggestionSecurityOption2ToJSON(
  dismissSkillSuggestionSecurityOption2: DismissSkillSuggestionSecurityOption2,
): string {
  return JSON.stringify(
    DismissSkillSuggestionSecurityOption2$outboundSchema.parse(
      dismissSkillSuggestionSecurityOption2,
    ),
  );
}

/** @internal */
export type DismissSkillSuggestionSecurity$Outbound = {
  Option1?: DismissSkillSuggestionSecurityOption1$Outbound | undefined;
  Option2?: DismissSkillSuggestionSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DismissSkillSuggestionSecurity$outboundSchema: z.ZodMiniType<
  DismissSkillSuggestionSecurity$Outbound,
  DismissSkillSuggestionSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DismissSkillSuggestionSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DismissSkillSuggestionSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function dismissSkillSuggestionSecurityToJSON(
  dismissSkillSuggestionSecurity: DismissSkillSuggestionSecurity,
): string {
  return JSON.stringify(
    DismissSkillSuggestionSecurity$outboundSchema.parse(
      dismissSkillSuggestionSecurity,
    ),
  );
}

/** @internal */
export type DismissSkillSuggestionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  DismissSkillSuggestionRequestBody: DismissSkillSuggestionRequestBody$Outbound;
};

/** @internal */
export const DismissSkillSuggestionRequest$outboundSchema: z.ZodMiniType<
  DismissSkillSuggestionRequest$Outbound,
  DismissSkillSuggestionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    dismissSkillSuggestionRequestBody:
      DismissSkillSuggestionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      dismissSkillSuggestionRequestBody: "DismissSkillSuggestionRequestBody",
    });
  }),
);

export function dismissSkillSuggestionRequestToJSON(
  dismissSkillSuggestionRequest: DismissSkillSuggestionRequest,
): string {
  return JSON.stringify(
    DismissSkillSuggestionRequest$outboundSchema.parse(
      dismissSkillSuggestionRequest,
    ),
  );
}
